export const extractLastNameComponent = (name: string | undefined) => {
  if (name === undefined) {
    return undefined;
  }

  const parts = name.split('/');
  if (parts.length <= 0) {
    return name;
  }

  return parts[parts.length - 1];
};

export const extractLastNameComponentFromName = (name: string) => {
  const parts = name.split('/');
  return parts[parts.length - 1];
};

// TODO: move this to workflow package when created
// Extract the workflow type from a name with
// pattern `workflows/<type>/instances/<instance-id>`
export const extractWorkflowFromInstanceName = (name: string | undefined) => {
  if (name === undefined) {
    return undefined;
  }

  const parts = name.split('/');
  if (parts.length <= 0) {
    return name;
  }

  return parts[1];
};

// This method intentionally does not use look-behind because it doesn't work in Safari
export const escapeName = (name: string | undefined) =>
  name?.replace(/([^\\])(?=\/)/g, '$1\\')?.replace(/^\//, '\\/');

export const workflowNameCasing = (displayName: string) => {
  // use lowercase for the first letter of each word
  // make sure A/B is capitalized
  const words = displayName.split(' ');
  return words
    .map(word => {
      if (word === 'A/B') {
        return word;
      }
      return word.charAt(0).toLowerCase() + word.slice(1);
    })
    .join(' ');
};
